import { FirearmStorageLocationService } from './firearm-storage-location.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { FIREARM_STORAGE_LOCATION_TYPE, FirearmStorageLocation } from 'assets-model';
import { Observable } from 'rxjs';



@Injectable({ providedIn: 'root' })
export abstract class FirearmStorageLocationResolverBase implements Resolve<FirearmStorageLocation> {

  constructor(protected service: FirearmStorageLocationService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<FirearmStorageLocation> {
    const key: number = FIREARM_STORAGE_LOCATION_TYPE.entityDecorator.toKeyObjectFromRouteParams(route.params);
    return this.service.get(key);
  }
}



